import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const EditIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M10.6253 2.91039C10.9521 2.58359 11.3953 2.4 11.8574 2.4C12.3196 2.4 12.7628 2.58359 13.0896 2.91039C13.4164 3.23718 13.6 3.68041 13.6 4.14256C13.6 4.60472 13.4164 5.04795 13.0896 5.37474L5.28581 13.1785L2 14L2.82145 10.7142L10.6253 2.91039Z"
                fill="none"
                // currentColor so that the MUI color prop reaches the stroke;
                // without it the icon ignored it and stayed on its own ink.
                stroke={props.htmlColor ?? 'currentColor'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
